/**
 * 設定テンプレートID
 */

/**
 * マスタ管理
 */

// 会員プロフィールマスタ画面
export const MEMBER_TEMPLATE = {
  // 検索項目生成テンプレートID
  SEARCH_TEMPLATE_ID: 2709,
  // 一覧項目テンプレートID
  SEARCH_RESULTS_TEMPLATE_ID: 2704,
  // 表示項目生成テンプレートID
  OUTPUT_TEMPLATE_ID: 1403,
  // CSV出力テンプレートID
  CSV_TEMPLATE_ID: 2714,
};

// 課題・ソリューションマスタ画面
export const AGENDA_SOLUTION_TEMPLATE = {
  // 検索項目生成テンプレートID
  SEARCH_TEMPLATE_ID: 2708,
  // 一覧項目テンプレートID
  SEARCH_RESULTS_TEMPLATE_ID: 2703,
  // 表示項目生成テンプレートID
  OUTPUT_TEMPLATE_ID: 1403,
  // CSV出力テンプレートID
  CSV_TEMPLATE_ID: 2713,
};

// 提案マスタ画面
export const SUGGEST_TEMPLATE = {
  // 検索項目生成テンプレートID
  SEARCH_TEMPLATE_ID: 2710,
  // 一覧項目テンプレートID
  SEARCH_RESULTS_TEMPLATE_ID: 2705,
  // 表示項目生成テンプレートID
  OUTPUT_TEMPLATE_ID: 1403,
  // CSV出力テンプレートID
  CSV_TEMPLATE_ID: 2715,
};

// 会員主催イベントマスタ画面
export const MEMBER_EVENT_TEMPLATE = {
  // 検索項目生成テンプレートID
  SEARCH_TEMPLATE_ID: 2707,
  // 一覧項目テンプレートID
  SEARCH_RESULTS_TEMPLATE_ID: 2702,
  // 表示項目生成テンプレートID
  OUTPUT_TEMPLATE_ID: 1403,
  // CSV出力テンプレートID
  CSV_TEMPLATE_ID: 2712,
};

// 分科会マスタ画面
export const SUBCOMMITTEE_TEMPLATE = {
  // 検索項目生成テンプレートID
  SEARCH_TEMPLATE_ID: 2706,
  // 一覧項目テンプレートID
  SEARCH_RESULTS_TEMPLATE_ID: 2701,
  // 表示項目生成テンプレートID
  OUTPUT_TEMPLATE_ID: 1403,
  // CSV出力テンプレートID
  CSV_TEMPLATE_ID: 2711,
};

// ダッシュボード画面
export const DASHBOARD_TEMPLATE = {
  // CSV出力テンプレートID
  MEMBER_COUNT_CSV_TEMPLATE_ID: 2801,
  PWD_SETTING_U_CSV_TEMPLATE_ID: 2802,
  PWD_SETTING_UU_CSV_TEMPLATE_ID: 2803,
  MONTH_LOGIN_U_CSV_TEMPLATE_ID: 2804,
  MONTH_LOGIN_UU_CSV_TEMPLATE_ID: 2805,
  AGENDA_REGIST_ORGANIZATION_CSV_TEMPLATE_ID: 2806,
  AGENDA_REGIST_CSV_TEMPLATE_ID: 2807,
  SOLUTION_REGIST_CSV_TEMPLATE_ID: 2808,
  SUGGEST_REGIST_CSV_TEMPLATE_ID: 2809,
  OPINION_EXCHANGE_CSV_TEMPLATE_ID: 2810,
  COOPERATION_START_CSV_TEMPLATE_ID: 2811,
  //集計
  MEMBER_COUNT_SUMCSV_TEMPLATE_ID: 2901,
  PWD_SETTING_U_SUMCSV_TEMPLATE_ID: 2902,
  PWD_SETTING_UU_SUMCSV_TEMPLATE_ID: 2903,
  MONTH_LOGIN_U_SUMCSV_TEMPLATE_ID: 2904,
  MONTH_LOGIN_UU_SUMCSV_TEMPLATE_ID: 2905,
  AGENDA_REGIST_ORGANIZATION_SUMCSV_TEMPLATE_ID: 2955,
  AGENDA_REGIST_SUMCSV_TEMPLATE_ID: 2906,
  SOLUTION_REGIST_SUMCSV_TEMPLATE_ID: 2907,
  SUGGEST_REGIST_SUMCSV_TEMPLATE_ID: 2908,
  OPINION_EXCHANGE_SUMCSV_TEMPLATE_ID: 2909,
  COOPERATION_START_SUMCSV_TEMPLATE_ID: 2911,
};
